
export default {
  getQestnList: { // 문의 내역 조회
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/qestn/getQestnList'
  },
  getQestnDesc: { // 문의 내역 상세 조회
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/qestn/getQestnDesc'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/myQestnApi.js